<template>
	<div>
		<VideoControl v-if="scenario" @subcommand="subcommand"></VideoControl>
		<div class="notice" v-else>Er is geen scenario geselecteerd.</div>
	</div>
</template>

<script>
import VideoControl from '../controls/VideoControl';
import BaseSlide from './BaseSlide';
export default {
	name: 'ScenarioVideoSlide',
	mixins: [BaseSlide],
	components: {
		VideoControl,
	},
	computed: {
		scenario(){
			return this.$actions.getVariable('scenario');
		},
	},
};
</script>

<style scoped></style>
